import {
  INIT_AUTH,
  INIT_AUTH_LOADING,
  INIT_AUTH_LOADED,
  INIT_AUTH_ERROR,
  PROFILE,
  PROFILE_ERROR,
  PROFILE_LOADED
} from '../actions/firebase';

const initialState = {
  auth: {
    isLoaded: false,
    isEmpty: true,
    error: null
  },
  profile: {
    isLoaded: false,
    isEmpty: true,
    error: null
  }
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case INIT_AUTH:
      if (!payload) {
        return {
          ...state,
          auth: {
            isEmpty: true,
            error: null
          },
          profile: {
            isLoaded: true,
            isEmpty: true,
            error: null
          }
        };
      } else {
        return {
          ...state,
          auth: {
            ...state.auth,
            isEmpty: false,
            ...payload
          }
        };
      }
    case INIT_AUTH_LOADING:
      return {
        ...state,
        auth: {
          ...state.auth,
          isLoaded: false
        }
      };
    case INIT_AUTH_LOADED:
      return {
        ...state,
        auth: {
          ...state.auth,
          isLoaded: true
        }
      };
    case INIT_AUTH_ERROR:
      return {
        ...state,
        auth: {
          ...state.auth,
          error: payload
        }
      };
    case PROFILE_LOADED:
      return {
        ...state,
        profile: {
          ...state.profile,
          isLoaded: true
        }
      };
    case PROFILE:
      if (!payload) {
        return {
          ...state,
          profile: {
            isEmpty: true,
            error: null
          }
        };
      } else {
        return {
          ...state,
          profile: {
            ...state.profile,
            isEmpty: false,
            ...payload
          }
        };
      }

    case PROFILE_ERROR:
      return {
        ...state,
        profile: {
          ...state.profile,
          error: payload
        }
      };
    default:
      return state;
  }
};
